export function truncateFileName(fileName: string): string {
    if (!fileName) return '';
    return fileName.length > 50 ? `${fileName.slice(0, 47)}...` : fileName;
}
